import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { notifyParent } from 'mailup-react-helpers'
import { PageHeader } from 'mailup-web-components'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { PAGE_STATE_INITIAL, pageState } from '../recoil/state/page'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { title, loading, status } = useRecoilValue(pageState)

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['EmailSendingMailingCS', redirectUrl])
  }, [redirectUrl])

  const goToSendStatus = () => {
    history.push('/messages/email/sendstatus/campaigns')
  }

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email',
      className: 'test-breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.SendStatus' }),
      'data-mu-test': 'breadcrumb-item__send-status',
      className: 'test-breadcrumb-item__send-status',
      url: '#',
      onClick: goToSendStatus
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.SendStatusCampaign' }),
      'data-mu-test': 'breadcrumb-item__send-status__campaigns',
      className: 'test-breadcrumb-item__send-status__campaigns',
      url: '#',
      onClick: goToSendStatus
    },
    {
      label: intl.formatMessage({
        id: 'Load.Schedulation.lblQueuePreviewRunning'
      }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    }
  ]

  return (
    <PageHeader
      loading={loading && status === PAGE_STATE_INITIAL}
      title={title}
      breadcrumbsItems={breadcrumbsItems}
    />
  )
}

export default Header
